<template>
  <q-badge :color="badgeColor" outline>
    {{ label }}
  </q-badge>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    badgeColor() {
      switch ((this.status || '').toUpperCase()) {
        case 'REQUESTED':
        case 'PENDING':
        case 'DRAFT':
          return 'blue'
        case 'APPROVED':
        case 'MAPPED':
        case 'ACTIVE':
        case 'CONFIRMED':
          return 'green'
        case 'PARTIAL':
          return 'orange'
        case 'REVIEW':
          return 'deep-orange'
        case 'REJECTED':
          return 'red'
        case 'INACTIVE':
          return 'grey'
        case 'UNMAPPED':
          return 'grey'
        default:
          return 'grey'
      }
    },
    label() {
      switch ((this.status || '').toUpperCase()) {
        case 'REQUESTED':
          return '요청 대기'
        case 'APPROVED':
          return '승인 완료'
        case 'MAPPED':
          return '정상 연결'
        case 'PARTIAL':
          return '부분 연결'
        case 'REVIEW':
          return '검토 필요'
        case 'PENDING':
          return '승인 대기'
        case 'REJECTED':
          return '반려'
        case 'UNMAPPED':
          return '미연결'
        case 'INACTIVE':
          return '비활성'
        case 'ACTIVE':
          return '활성'
        case 'DRAFT':
          return '가등록'
        case 'CONFIRMED':
          return '확정등록'
        default:
          return (this.status || 'UNKNOWN').toUpperCase()
      }
    }
  }
}
</script>
